import { useEffect, useRef } from 'react';

// Cache the scrollbar width globally across all components to avoid repeated forced reflows
let cachedScrollbarWidth: number | null = null;

const getScrollbarWidth = (): number => {
  if (cachedScrollbarWidth !== null) {
    return cachedScrollbarWidth;
  }

  // Create a temporary element to measure scrollbar width without triggering layout
  const scrollDiv = document.createElement('div');
  scrollDiv.style.cssText =
    'width:100px;height:100px;overflow:scroll;position:absolute;opacity:0;pointer-events:none;';
  document.body.appendChild(scrollDiv);
  cachedScrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  scrollDiv.remove();

  return cachedScrollbarWidth;
};

export const useBodyScrollLock = (anchorEl: HTMLElement | null) => {
  const originalBodyStyleRef = useRef<{
    overflow: string;
    paddingRight: string;
  }>({ overflow: '', paddingRight: '' });

  useEffect(() => {
    if (anchorEl) {
      // Store original styles
      originalBodyStyleRef.current = {
        overflow: document.body.style.overflow,
        paddingRight: document.body.style.paddingRight,
      };

      // Apply scroll lock with cached scrollbar width
      const scrollbarWidth = getScrollbarWidth();
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      // Restore original styles
      document.body.style.overflow = originalBodyStyleRef.current.overflow;
      document.body.style.paddingRight = originalBodyStyleRef.current.paddingRight;
    };
  }, [anchorEl]);
};
